'use strict';
import * as $j_app$002edata$002e$002dApp$002dUser$0024$002dFirebase$002dUser$0024$0024anon$00241 from "./app.data.-App-User$-Firebase-User$$anon$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppUser$FirebaseUser$() {
  this.azN = null;
  this.azO = false;
}
export { $c_Lapp_data_AppUser$FirebaseUser$ as $c_Lapp_data_AppUser$FirebaseUser$ };
$p = $c_Lapp_data_AppUser$FirebaseUser$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppUser$FirebaseUser$;
/** @constructor */
function $h_Lapp_data_AppUser$FirebaseUser$() {
}
export { $h_Lapp_data_AppUser$FirebaseUser$ as $h_Lapp_data_AppUser$FirebaseUser$ };
$h_Lapp_data_AppUser$FirebaseUser$.prototype = $p;
$p.brO = (function() {
  if ((!this.azO)) {
    this.azN = new $j_app$002edata$002e$002dApp$002dUser$0024$002dFirebase$002dUser$0024$0024anon$00241.$c_Lapp_data_AppUser$FirebaseUser$$anon$1();
    this.azO = true;
  }
  return this.azN;
});
var $d_Lapp_data_AppUser$FirebaseUser$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppUser$FirebaseUser$, "app.data.AppUser$FirebaseUser$", ({
  Cy: 1
}));
export { $d_Lapp_data_AppUser$FirebaseUser$ as $d_Lapp_data_AppUser$FirebaseUser$ };
var $n_Lapp_data_AppUser$FirebaseUser$;
function $m_Lapp_data_AppUser$FirebaseUser$() {
  if ((!$n_Lapp_data_AppUser$FirebaseUser$)) {
    $n_Lapp_data_AppUser$FirebaseUser$ = new $c_Lapp_data_AppUser$FirebaseUser$();
  }
  return $n_Lapp_data_AppUser$FirebaseUser$;
}
export { $m_Lapp_data_AppUser$FirebaseUser$ as $m_Lapp_data_AppUser$FirebaseUser$ };
//# sourceMappingURL=app.data.-App-User$-Firebase-User$.js.map
